export interface Device {
  id: number;
  name: string;
  brand: string | null;
  model: string | null;
  description: string | null;
  serial_number: string;
  company: number | null;
  company_name: string | null;
  // false = waiting for approval: the headset cannot log in
  enabled: boolean;
  // '' = still to be filled in (devices registered before 02/11, or the headset app asking by itself)
  device_type?: DeviceType | '';
  usage?: DeviceUsage | '';
  requested_by?: number | null;
  requested_by_name?: string | null;
  requested_for?: number | null;
  requested_for_name?: string | null;
  requested_at?: string | null;
}

export type DeviceType = 'headset' | 'phone';
// unity = XR Support app for assisted video calls (headset or phone), 6dof = motion tracking, other = always a phone
export type DeviceUsage = 'unity' | '6dof' | 'other';
export const DEVICE_TYPES: DeviceType[] = ['headset', 'phone'];
export const DEVICE_USAGES: DeviceUsage[] = ['unity', '6dof', 'other'];
